export default "__VITE_ASSET__df189505__"